import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  accessUrl: plaintextValidator(config),
  clientId: plaintextValidator(config),
  clientSecret: plaintextValidator(config)
};
